import React, {useState, useEffect} from 'react';
import { Layout, Menu, Breadcrumb, Input } from 'antd';
import {Col,Row, Form, Button} from 'react-bootstrap';
import { Segment } from 'semantic-ui-react';
import './Demo.css';
import {proteinSet} from './Common.js';
import SideMenu from './SideMenu';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { TextArea } = Input;

export default function Tool08() {

    const [count, setCount] = useState("");
    const [length, setLength] = useState("");
    const [result, setResult] = useState([]);
    
    function handleCount(e){
        let current = e.target.value;
        // console.log(current);
        setCount(current);
    }

    function handleLength(e){
        let current = e.target.value;
        setLength(current);
    }

    function handleSubmit(){
        var allStr = length;
        var num = count;
        let resultArr=[]
        for (var j = 0; j < num; j++) {
            var result1 = "";
            for (var i = 0; i < allStr; i++) {
                var id = Math.floor(Math.random() * proteinSet.length);
                result1 += proteinSet[id];
            }
            resultArr.push(result1);
        }
        // document.getElementById("demo").innerHTML = resultArr;
        setResult(resultArr);
    }

    return (

        <Layout style={{height: "100vh"}}>
            <Header className="header" style={{minHeight: "5vh"}}>
                <div style={{fontSize:"2rem",color:"white"}}>BioTools</div>
            </Header>
            <Content style={{ padding: '5vh 50px', minHeight: "80vh",maxHeight:"80vh"}}>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item style={{fontSize:"1.5rem"}}>Tools 01</Breadcrumb.Item>
            </Breadcrumb> */}
            <Layout className="site-layout-background" >
                <Sider className="site-layout-background" width={200}>
                    <SideMenu params={["9"]} />
                </Sider>
                <Content style={{ background:"white", minHeight: "75vh",maxHeight:"75vh" }}>
                    <Segment basic style={{height:"100%"}} >
                        <Segment style={{height:"100%"}} >
                            <Row>
                                <Col sm={1} />
                                <Col>
                                    <Form>
                                        <div style={{height:"1rem"}} />
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">数量(num)</Form.Label>
                                            <Form.Control type="number" onChange={handleCount}  />
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">长度(len)</Form.Label>
                                            <Form.Control type="number" onChange={handleLength}  />
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />

                                        <Button onClick={handleSubmit}>提交</Button>

                                        <div style={{height:"3rem"}} />

                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label size="lg">结果</Form.Label>
                                            <TextArea
                                                value={result.toString().replaceAll(",","\n")}
                                                // placeholder="Controlled autosize"
                                                autoSize={{ maxRows: 5 }}
                                                // disabled
                                                bordered={false}
                                            />
                                            {/* <div id="demo"></div> */}
                                            
                                            
                                        </Form.Group>
                                        <div style={{height:"1rem"}} />
                                    </Form>
                                </Col>
                                <Col sm={1} />
                            </Row>
                        </Segment>
                    </Segment>
                </Content>
            </Layout>
            </Content>
            <Footer style={{ textAlign: 'center',minHeight: "10vh" }}>TIB ©2021 Created by Biodesign Center</Footer>
        </Layout>
    )
}
